import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import RegisterPageForm from "./RegisterPageForm";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: "50px", // space for fixed footer
  },
}));

function RegisterPage(props) {
  useEffect(() => {}, []);

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <RegisterPageForm />
    </div>
  );
}

export default RegisterPage;
